import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    
    // Get the current path without any language prefix
    const pathWithoutLang = location.pathname.replace(/^\/(en|fr|de)/, '');
    
    // For English, use the root path without language prefix
    // For other languages, add the language prefix
    const newPath = lang === 'en' 
      ? (pathWithoutLang || '/') // If pathWithoutLang is empty, use '/'
      : `/${lang}${pathWithoutLang || '/'}`; // If pathWithoutLang is empty, use '/lang'
    
    navigate(newPath);
  };

  return (
    <select 
      value={i18n.language} 
      onChange={(e) => changeLanguage(e.target.value)}
      className="bg-transparent border border-white/20 rounded-lg px-2 py-1"
    >
      <option value="en">English</option>
      <option value="fr">Français</option>
      <option value="de">Deutsch</option>
    </select>
  );
} 